import { Text } from '@shared/components/Text';
import { TodoField } from '@shared/data/entity/fields/TodoField';
import { i18n } from '@shared/util/i18n';
import { CardCollectionViewFieldContainer } from './CardCollectionViewFieldContainer';

interface Props {
  field: TodoField;
}

export function TodoCollectionViewField({ field }: Props) {
  if (field.isEmpty) {
    return null;
  }

  return (
    <CardCollectionViewFieldContainer fieldType={field.fieldType}>
      <Text size="body1">
        {i18n('card.blocks.todo.summary', {
          completedCount: field.todos.filter(item => item.status === 'COMPLETED').length,
          count: field.todos.length,
        })}
      </Text>
    </CardCollectionViewFieldContainer>
  );
}
